import { render, staticRenderFns } from "./ExibirCDAEnviadasCRA.vue?vue&type=template&id=82f7c444&"
import script from "./ExibirCDAEnviadasCRA.vue?vue&type=script&lang=js&"
export * from "./ExibirCDAEnviadasCRA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports